export class AzureConsentUrlResponse {
    'url';
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureConsentUrlResponse.attributeTypeMap;
    }
    constructor() {
    }
}
